import SeoHead from "@/Component/Seo/SeoHead";
import Cart from "@/Component/Module/Cart";
import { fetchPageSeo, getDataLayerAuth } from "@/utils/pageSeo";

export default function CartPage({ seo, seoCountry }) {
  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle="Cart | Next Holidays" noIndex />
      <Cart />
    </>
  );
}

export async function getServerSideProps(context) {
  const seoResult = await fetchPageSeo(context, {
    path: "/cart",
    dataLayerPayload: {
      module: "cart",
      events: "add_to_cart",
      slug: null,
      ...getDataLayerAuth(context),
    },
  });
  if (seoResult.redirect) return seoResult;

  return {
    props: {
      seo: seoResult.seo,
      seoCountry: seoResult.seoCountry,
    },
  };
}
